import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { ApolloProvider } from 'react-apollo'
import { toast } from 'react-toastify'
import map from 'lodash/map'
import get from 'lodash/get'

import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { createUploadLink } from 'apollo-upload-client'
import { ApolloLink, Observable } from 'apollo-link'
import { onError } from 'apollo-link-error'
import DebounceLink from 'apollo-link-debounce'

import store from 'store/configureStore'
import AppSwitch from 'config/routes'
import ToastErrors from 'components/ToastErrors'

import 'semantic-ui-css/semantic.min.css'
import 'react-datetime/css/react-datetime.css'
import '@reach/dialog/styles.css'

const uri = process.env.LOCAL_DEV ? 'http://localhost:3500/graphql' : '/graphql'

const request = async operation => {
  const ucn = await localStorage.getItem('ucn')
  const token = await localStorage.getItem('token')
  operation.setContext({
    headers: {
      ucn,
      token,
    },
  })
}

const requestLink = new ApolloLink(
  (operation, forward) =>
    new Observable(observer => {
      let handle
      Promise.resolve(operation)
        .then(oper => request(oper))
        .then(() => {
          handle = forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer),
          })
        })
        .catch(observer.error.bind(observer))

      return () => {
        if (handle) handle.unsubscribe()
      }
    }),
)

function handleErrors(graphQLErrors, networkError) {
  const errorMessages = map(graphQLErrors, ({ extensions, message }) => {
    const {
      status,
      data: { errorCode, errorMsg },
    } = get(extensions, 'exception.response', { data: {} })

    if (status === 450) {
      return 'Invalid input. Missing required fields or details'
    }

    return `${errorCode} ${errorMsg} ${message}`
  })

  if (networkError) errorMessages.push(networkError.message)
  toast.error(<ToastErrors errors={errorMessages} />)
}

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      console.error(
        `[GraphQL]: Message: ${message}, Location: ${locations}, Path: ${path}`,
      ),
    )

  if (networkError) console.error(`[Network error]: ${networkError}`)
  handleErrors(graphQLErrors, networkError)
})

const debounceLink = new DebounceLink(100)
const cache = new InMemoryCache()

const client = new ApolloClient({
  link: ApolloLink.from([
    errorLink,
    requestLink,
    debounceLink,
    createUploadLink({ uri }),
  ]),
  cache,
})

ReactDOM.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <BrowserRouter>{AppSwitch}</BrowserRouter>
    </Provider>
  </ApolloProvider>,
  document.getElementById('root'),
)
